var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoryBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4116_7262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00323 49.6536L0.333971 5.1754C0.278842 3.70646 1.40517 2.46155 2.87229 2.36986L40.7041 0.00536793C42.1975 -0.0879661 43.4837 1.04697 43.5771 2.54031C43.5806 2.59658 43.5823 2.65294 43.5823 2.70931V51.1762C43.5823 52.6724 42.3694 53.8854 40.8731 53.8854C40.8326 53.8854 40.7921 53.8845 40.7516 53.8827L4.58898 52.2585C3.1806 52.1952 2.0561 51.0624 2.00323 49.6536Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4116_7262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00323 49.6536L0.333971 5.1754C0.278842 3.70646 1.40517 2.46155 2.87229 2.36986L40.7041 0.00536793C42.1975 -0.0879661 43.4837 1.04697 43.5771 2.54031C43.5806 2.59658 43.5823 2.65294 43.5823 2.70931V51.1762C43.5823 52.6724 42.3694 53.8854 40.8731 53.8854C40.8326 53.8854 40.7921 53.8845 40.7516 53.8827L4.58898 52.2585C3.1806 52.1952 2.0561 51.0624 2.00323 49.6536Z",
    fill: "#B42F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2687 6.62338L32.5271 0.408214L37.7225 0L37.9463 6.40948C37.9541 6.63255 37.7796 6.81969 37.5566 6.82748C37.461 6.83082 37.3674 6.80019 37.2924 6.74105L35.2888 5.16274L32.9167 6.96215C32.7389 7.09704 32.4854 7.06224 32.3505 6.88441C32.2937 6.80955 32.2648 6.71725 32.2687 6.62338ZM25.6242 20.3101C25.6242 21.3642 32.7241 20.859 33.6772 20.1186C33.6772 12.9408 29.8257 9.16902 22.7731 9.16902C15.7205 9.16902 11.769 12.9995 11.769 18.7453C11.769 28.7525 25.274 28.944 25.274 34.4024C25.274 35.9346 24.5238 36.8444 22.8732 36.8444C20.7224 36.8444 19.872 35.746 19.9721 32.0112C19.9721 31.201 11.769 30.9484 11.5189 32.0112C10.8821 41.0618 16.5208 43.6724 22.9732 43.6724C29.2255 43.6724 34.1273 40.3397 34.1273 34.3067C34.1273 23.5813 20.4222 23.8686 20.4222 18.5537C20.4222 16.3991 22.0228 16.1118 22.9732 16.1118C23.9736 16.1118 25.7742 16.2881 25.6242 20.3101Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryBook);
export default __webpack_public_path__ + "static/media/storyBook.562d7050a109c613b1ac09be68fb6fbb.svg";
export { ForwardRef as ReactComponent };